import React from 'react';
import styles from './styles.module.scss';
import { gameSupportLink, menuList, parnershipLink, socialNetworkLink } from './config';
import logo from 'assets/img/thetan_logo_full_V2.png';

const Footer = () => {
  const renderLogo = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.copyright
    }, /*#__PURE__*/React.createElement("img", {
      draggable: false,
      src: logo,
      className: styles.logo
    }), /*#__PURE__*/React.createElement("span", null, new Date().getFullYear(), "\xA9 Wolffun Game. All rights reserved."));
  };

  const renderMenuList = menu => {
    return /*#__PURE__*/React.createElement(React.Fragment, null, menu.map(e => /*#__PURE__*/React.createElement("a", {
      key: e.name,
      onClick: e.handlePress,
      href: e.href,
      target: "_blank",
      className: styles.menuItem,
      rel: "noreferrer"
    }, e.name)));
  };

  const renderMenuSection = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.tableMenu
    }, menuList.map(menu => /*#__PURE__*/React.createElement("div", {
      key: `menu-${menu.name}`
    }, renderMenuList(menu.children))));
  };

  const renderCommunity = () => {
    return /*#__PURE__*/React.createElement("div", {
      className: styles.community
    }, /*#__PURE__*/React.createElement("span", {
      className: styles.menuSection
    }, "Join our Community"), /*#__PURE__*/React.createElement("div", {
      className: styles.iconList
    }, socialNetworkLink.map(({
      icon,
      link
    }) => /*#__PURE__*/React.createElement("a", {
      href: link,
      target: "_blank",
      rel: "noreferrer",
      key: link
    }, /*#__PURE__*/React.createElement("img", {
      src: icon,
      className: styles.icon
    })))));
  };

  const renderParnership = () => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: styles.parnership
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, parnershipLink.label, /*#__PURE__*/React.createElement("span", null, ":")), /*#__PURE__*/React.createElement("div", {
    className: styles.linkList
  }, parnershipLink.chidren.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.label
  }, /*#__PURE__*/React.createElement("span", null, item.label), /*#__PURE__*/React.createElement("span", null, ":"), /*#__PURE__*/React.createElement("a", {
    href: item.email,
    target: "_blank",
    className: styles.link,
    rel: "noreferrer"
  }, "Email Us"), /*#__PURE__*/React.createElement("span", null, "|"), /*#__PURE__*/React.createElement("a", {
    href: item.signup,
    target: "_blank",
    className: styles.link,
    rel: "noreferrer"
  }, "Sign Up"))))), /*#__PURE__*/React.createElement("div", {
    className: styles.gameSupport
  }, /*#__PURE__*/React.createElement("span", {
    className: styles.title
  }, gameSupportLink.label, /*#__PURE__*/React.createElement("span", null, ":")), /*#__PURE__*/React.createElement("div", {
    className: styles.linkList
  }, gameSupportLink.children.map(item => /*#__PURE__*/React.createElement("div", {
    key: item.label
  }, /*#__PURE__*/React.createElement("img", {
    src: item.icon,
    className: styles.icon
  }), /*#__PURE__*/React.createElement("a", {
    href: item.link,
    target: "_blank",
    className: styles.link,
    rel: "noreferrer"
  }, item.label))))));

  return /*#__PURE__*/React.createElement("footer", {
    className: styles.footer
  }, renderLogo(), renderMenuSection(), renderCommunity(), /*#__PURE__*/React.createElement("div", {
    className: styles.breakDiv
  }), renderParnership());
};

export default Footer;